import { SagaIterator } from 'redux-saga';
import { put, call, select, delay } from 'redux-saga/effects';
import Api from '../../../modules/utils/API';
import { changeModalState, errorsGlobalError, updateWatermarkProcessed } from '../../actions';
import ApiErrors from '../../../modules/utils/API/APIErrors';
import { ISagaAction } from '../../types';
import { IStartWatermarksProcessingAction } from '../../types/watermarks';
import {
  getCollectionId,
  getImagesByGalleryID,
  getTotalImagesCountForWatermark
} from '../../selectors';

export const startWaterMarkProcessingSaga = function* ({
  payload
}: ISagaAction<IStartWatermarksProcessingAction>): SagaIterator {
  const collection_id = yield select(getCollectionId);
  const { gallery_id } = payload;

  if (gallery_id) {
    const galleryImages = yield select((state) => getImagesByGalleryID(state)(gallery_id));
    if (!galleryImages.length) return;
  }

  let stopProcess = false;

  yield put(changeModalState({ key: 'watermarkProcessingModal', state: true }));

  while (!stopProcess) {
    try {
      const response = yield call(Api.Watermarks.processing, { ...payload, collection_id });
      ApiErrors.checkOnApiError(response);
      const { processedWatermarksCount } = response;

      const totalImagesCount: number = gallery_id
        ? yield select((state) => {
            const images = getImagesByGalleryID(state)(gallery_id) || [];

            return images.reduce(
              (count, img) =>
                count +
                (img?.status === 'uploaded' && img?.extension?.toLowerCase() !== 'gif' ? 1 : 0),
              0
            );
          })
        : yield select(getTotalImagesCountForWatermark);

      yield put(updateWatermarkProcessed({ ...response, totalImagesCount }));

      if (totalImagesCount > 0 && processedWatermarksCount >= totalImagesCount) {
        stopProcess = true;
        yield delay(5000);
        yield put(changeModalState({ key: 'watermarkProcessingModal', state: false }));
      }
    } catch (e) {
      stopProcess = true;
      yield put(changeModalState({ key: 'watermarkProcessingModal', state: false }));
      yield put(errorsGlobalError(e as ErrorEvent));
    }

    yield delay(5000);
  }
};
